<template lang="pug">
    #app
        vue-progress-bar
        router-view
</template>

<script>
export default {
	name: "app"
};
</script>
